import { Utils } from "../../../../shared/utils";

export class ReserveConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta contable', cell: (row) => `${row.accountingModelsNumber}`, class: (row) => `` },
    { field: 'reserveTypeName', title: 'Tipo de Reserva', cell: (row) => `${row.reserveTypeName}`, class: (row) => `` },
    { field: 'amount', title: 'Importe', cell: (row) => Utils.FormatMoney(row.amount) + ' €', class: (row) => `` }
  ];
}